import React, { useContext, useEffect, useState } from 'react'
import { ApiGetCallAuthKey, ApiPostCall } from '../../JS/Connector';
import { GetBuildingGrade, LogInSchoolID } from '../../JS/Common';
import Deletepopup from '../../Components/Deletepopup';
import AlertsComp from '../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import useConfig from '../../Hooks/useConfig';
import SettingBoxWrapper from './SettingBoxWrapper';

export default function ArchiveUsersDetails({ setLoading, setNewAlerts }) {
    const { students, department } = useConfig();
    const navigate = useNavigate();
    const [GradeArray, setGradeArray] = useState([]);
    const [grade, setgrade] = useState(0);
    const [ErrorMsg, setErrorMsg] = useState('');
    const [DecommissionPopup, setDecommissionPopup] = useState(false);
    useEffect(() => {
        GetBuildingGrade({ setGradeArray });
    }, [])
    function gradeValueChange() {
        if (parseInt(grade) == 0) {
            setErrorMsg('Select at least one grade.')
        } else {
            setDecommissionPopup(true)
        }
    }
    async function DecommissionUsersCall() {
        setLoading(true);
        await ApiPostCall(`/allocations/deallocate-users?schoolId=${LogInSchoolID}&grade=${grade}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"User Deallocated Successfully"} />);
                    setTimeout(() => {
                        setDecommissionPopup(false)
                        navigate('/users')
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    return (
        <>
            <SettingBoxWrapper
                BoxTitle={'Archive Users'}
                BoxLabel={`This functionality empowers you to streamline your panel by effortlessly managing the visibility of ${students || 'students'} based on their respective ${department || 'department'}s.
                    Here's how it works: simply select a ${department || 'department'} from the dropdown menu, and with a single click of the "Archive Users" button,
                    all ${students || 'students'} belonging to the chosen ${department || 'department'} will be seamlessly removed from your panel.
                    This means that those users will no longer be visible or accessible within your system,
                    allowing you to focus on the specific groups you wish to engage with.`}
                labelCustomClass={'text-justify'}
            >
                <div className="row d-flex pt-3 pb-2">
                    <div className="col-5 py-1 ">
                        <select defaultValue={grade} onChange={(e) => { setgrade(e.target.value) }}>
                            <option value="0">Select {department || 'Department'}</option>
                            {GradeArray.map((item, j) => (
                                <option value={item.grade} key={j}>
                                    {item.grade}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-7 ">
                        {grade == 0 ?
                            <label className='BorderBtn' onClick={(e) => { gradeValueChange(e) }}>Archive Users </label>
                            :
                            <label className='BorderBtn' onClick={(e) => { gradeValueChange(e) }} style={{ backgroundColor: "var(--primary-color)", color: 'white' }}>Archive Users </label>
                        }
                    </div>

                </div>
                <div className='ps-4 redText'>{ErrorMsg}</div>
            </SettingBoxWrapper>
            <Deletepopup text={`This will archive all users/students from the ${grade} option. Those users/students will not be part of your panel anymore and will not be visible.`} deletePopup={DecommissionPopup} size="xl"
                deletePart={DecommissionUsersCall} DeleteShowClose={(e) => setDecommissionPopup(false)} />
        </>
    )
}
